import React from "react";
import ActiveScofflawsTable from "./ActiveScofflawsTable";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export const ActiveScofflaws: React.FC = () => {
  return (
    <Stack direction="column" sx={{ height: "100%" }}>
      <Container maxWidth="xl" sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
        <Stack direction="column" spacing={3} sx={{ flexGrow: 1 }}>
          <Box>
            <Typography variant={"h4"} fontWeight={600}>
              Active Scofflaws
            </Typography>
            <Typography variant={"subtitle1"} color={"text.disabled"} fontSize={"0.75rem"}>
              Vehicles in active scofflaw status
            </Typography>
          </Box>
          <ActiveScofflawsTable />
        </Stack>
      </Container>
    </Stack>
  );
};

export default ActiveScofflaws;
